import { render, staticRenderFns } from "./userCenterSidebar.vue?vue&type=template&id=63c6c0c0&scoped=true"
import script from "./userCenterSidebar.vue?vue&type=script&lang=js"
export * from "./userCenterSidebar.vue?vue&type=script&lang=js"
import style0 from "./userCenterSidebar.vue?vue&type=style&index=0&id=63c6c0c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c6c0c0",
  null
  
)

export default component.exports